import Dashboard from './Dashboard'
import DashboardGuard from './guards/DashboardGuard'
import DashboardMain from './DashboardMain'
import Enrollment from './enrollment/EnrollmentIndex'
import ExplanationRoute from './explanation/route'
import DataRoute from './data/route'
import GroupPayment from './GroupPayment'
import HelpRoute from './help/route'
import Payment from './payment/PaymentIndex'
import PeriodRoute from './period/route'
import QuestionBankRoute from './questionbank/route'
import RegistrationRoute from './registration/route'
import Settings from './Settings'
import TryoutRoute from './tryout/route'
import UserRoute from './user/route'
import PaymentCallback from '@/views/payment/PaymentCallback'
import CheckImportRoute from './checkimport/route.js'
import LinkRoute from './link/route.js'
import RegistrationLinkRoute from './registrationLink/route.js'
import KelonRoute from './kelon/route.js'

export default [
    {
        path: '/dashboard',
        component: Dashboard,
        beforeEnter: DashboardGuard,
        children: [
            {
                path: 'pembayaranSelesai',
                component: PaymentCallback,
                name: 'paymentCallback',
            },
            {
                path: '',
                component: DashboardMain,
                name: 'dashboard',
                meta: { title: 'Dashboard' },
            },
            {
                path: 'pengaturan',
                component: Settings,
                name: 'settings',
                meta: { title: 'Pengaturan' },
            },
            {
                path: 'pembayaran',
                component: Payment,
                name: 'payment',
                meta: { title: 'Pembayaran' },
            },
            {
                path: 'pembayarankelompok',
                component: GroupPayment,
                name: 'groupPayment',
                meta: { title: 'Pembayaran Kelompok' },
            },
            {
                path: 'registrasi',
                component: Enrollment,
                name: 'enrollment',
                meta: { title: 'Pendaftaran Baru' },
            },
            ...ExplanationRoute,
            ...DataRoute,
            ...HelpRoute,
            ...PeriodRoute,
            ...QuestionBankRoute,
            ...RegistrationRoute,
            ...TryoutRoute,
            ...UserRoute,
            ...CheckImportRoute,
            ...LinkRoute,
            ...RegistrationLinkRoute,
            ...KelonRoute,
        ],
    },
]
